export async function getZona(id) {
    return new Promise((resolve) => {
        var datos = [
            { nombre: 'Centro', zona: { telefono: "+57 3203703495" } },
            { nombre: 'Santander', zona: { telefono: "+57 3182754576" } },
            { nombre: 'Antioquia', zona: { telefono: "+57 3213782946" } },
            { nombre: 'Eje Cafetero', zona: { telefono: "+57 3203698673" } },
            { nombre: 'Norte de Santander', zona: { telefono: "+57 3144417876" } },
            { nombre: 'Costa', zona: { telefono: "+57 3212228848" } },
            { nombre: 'Occidente', zona: { telefono: "+57 3175860335" } },
            { nombre: 'Exterior', zona: { telefono: "+57 3213782946" } },
        ]
        var asesor = false;
        var url = id
        datos.forEach(element => {
            if (element.nombre === id) {
                asesor = true;
                url = element.zona
            }
        });

        if (asesor) {
            resolve(url)
        } else {
            resolve(false)
        }
    })
}


export async function getGestoresComerciales(id) {
    return new Promise((resolve) => {
        var datos = [
            { "nombre": "ANDRES FELIPE ZAPATA DUQUE", "gestor": { "telefono": "+57 3176482520" } },
            { "nombre": "JUAN PABLO LOPEZ RODAS", "gestor": { "telefono": "+57 3176482520" } },
            { "nombre": "GABRIEL VELASQUEZ RAMIREZ", "gestor": { "telefono": "+57 3102897475" } },
            { "nombre": "JHON FREDY RAMIREZ MARIN", "gestor": { "telefono": "+57 3203698673" } },
            { "nombre": "SERGIO ALBERTO CORREA ARCILA", "gestor": { "telefono": "+57 3107934714" } },
            { "nombre": "ADOLFO LEON VILLEGAS PIEDRAHITA", "gestor": { "telefono": "+57 3107934714" } },
            { "nombre": "DANIEL RESTREPO ROLDAN", "gestor": { "telefono": "+57 3107934714" } },
            { "nombre": "ANDRES FELIPE RESTREPO MUÑOZ", "gestor": { "telefono": "+57 3183476189" } },
            { "nombre": "JUAN DAVID MESA CARDENAS", "gestor": { "telefono": "+57 3156203075" } },
            { "nombre": "JOHNNATAN VASQUEZ GARCIA", "gestor": { "telefono": "+57 3176482520" } },
            { "nombre": "JOSE RAFAEL LOPEZ BERROCAL", "gestor": { "telefono": "+57 3156203075" } },
            { "nombre": "FAIBER RODRIGUEZ SONS", "gestor": { "telefono": "+57 3175860332" } },
            { "nombre": "DAISSY ANDREA RAMOS ARIAS", "gestor": { "telefono": "+57 3175860332" } },
            { "nombre": "HEIDE SILVA CASAS", "gestor": { "telefono": "+57 3175860332" } },
            { "nombre": "NIXON LOPEZ CARVAJAL", "gestor": { "telefono": "+57 3183585525" } },
            { "nombre": "JOHANA PATRICIA OSORIO PEREZ", "gestor": { "telefono": "+57 3203703495" } },
            { "nombre": "EDILSON LOPEZ CARVAJAL", "gestor": { "telefono": "+57 3245784629" } },
            { "nombre": "JHONATAN ALEXANDER AYA GAMBA", "gestor": { "telefono": "+57 3212228966" } },
            { "nombre": "LILIANA RODRIGUEZ MURILLO", "gestor": { "telefono": "+57 3212228966" } },
            { "nombre": "JARI ESTEFANIA AVILA DUARTE", "gestor": { "telefono": "+57 3203703495" } },
            { "nombre": "CINDY YURIANA AGUAYO LOPEZ", "gestor": { "telefono": "+57 3203703495" } },
            { "nombre": "VICTOR RAFAEL VELASQUEZ RAMOS", "gestor": { "telefono": "+57 3183585525" } },
            { "nombre": "JORGE ELIECER NUÑEZ IBAÑEZ", "gestor": { "telefono": "+57 3183585525" } },
            { "nombre": "OSCAR JAVIER JIMENEZ THERAN", "gestor": { "telefono": "+57 3245784629" } },
            { "nombre": "SANDRA LILIANA VALENCIA CORREA", "gestor": { "telefono": "+57 3203698673" } },
            { "nombre": "ANDRES JULIAN QUINTERO ZULUAGA", "gestor": { "telefono": "+57 3203698673" } },
            { "nombre": "DORA DANIELA GONZALEZ URREGO", "gestor": { "telefono": "+57 3203698673" } },
            { "nombre": "JULETZY ANDREA CASTILLA RIVERA", "gestor": { "telefono": "+57 3144417876" } },
            { "nombre": "EDISON ALEXIS ROJAS HURTADO", "gestor": { "telefono": "+57 3144417876" } },
            { "nombre": "DIEGO CASTRO VIAFARA", "gestor": { "telefono": "+57 3212228894" } },
            { "nombre": "JHON ALEXANDER OROZCO CORRALES", "gestor": { "telefono": "+57 3212228894" } },
            { "nombre": "ANDRES FELIPE SUAREZ PINO", "gestor": { "telefono": "+57 3175860335" } },
            { "nombre": "MAURICIO HERNANDEZ HERRERA", "gestor": { "telefono": "+57 3175860335" } },
            { "nombre": "JEYSON QUIJANO SARMIENTO", "gestor": { "telefono": "+57 3182754576" } },
            { "nombre": "CAMILO ANDRES GIL RESTREPO", "gestor": { "telefono": "+57 3182754576" } },
            { "nombre": "WILDER YAMIT QUITIAN MATEUS", "gestor": { "telefono": "+57 3182754576" } },
            { "nombre": "JOSE LEONARDO GARCES MORALES", "gestor": { "telefono": "+57 3173311389" } },
            { "nombre": "ANDREA ZULUAGA MAZO", "gestor": { "telefono": "+57 3102897475" } },
            { "nombre": "ESTIBEN MORALES GARCIA", "gestor": { "telefono": "+57 3156203075" } },
            { "nombre": "MARTHA CECILIA JAIMES VALENCIA", "gestor": { "telefono": "+57 3156203075" } },
            { "nombre": "OLGA LUCIA CASTRO GUALTERO", "gestor": { "telefono": "+57 3102897475" } },
            { "nombre": "ALEXANDER PINILLA GARZON", "gestor": { "telefono": "+57 3102897475" } },
            { "nombre": "ORFY ANDREA MACHADO SERNA", "gestor": { "telefono": "+57 3102897475" } },
            { "nombre": "CARMEN ELISA LOPEZ GOMEZ", "gestor": { "telefono": "+57 3212228894" } },
            { "nombre": "PEDRO PABLO CALI MARTINEZ", "gestor": { "telefono": "+57 3245784629" } },
            { "nombre": "FRANCY SORLEY CAÑAVERAL CAÑAVERAL", "gestor": { "telefono": "+57 3174041093" } },
            { "nombre": "LAURA MILENA GUZMAN HINCAPIE", "gestor": { "telefono": "+57 3174041093" } },
            { "nombre": "BLANCA MILENA BONILLA", "gestor": { "telefono": "+57 3174041093" } }
        ]
        var asesor = false;
        var url = id
        datos.forEach(element => {
            if (element.nombre === id) {
                asesor = true;
                url = element.gestor
            }
        });

        if (asesor) {
            resolve(url)
        } else {
            resolve(false)
        }
    })
}